export const OPEN_LOGIN_DIALOG= 'OPEN_LOGIN_DIALOG'
export const openLoginDialog=(_openState)=>({
    type:OPEN_LOGIN_DIALOG,
    payload: _openState   
})